module.exports = __webpack_public_path__ + "stylesheets/political-landing_afa02ffcf05bf802105738705fe72e67.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/political-landing.less
// module id = Rpkd
// module chunks = 118